import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/admin/foundation/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/foundation/add',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/admin/foundation/update',
      data
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  }
};
